import React from 'react';
import { Table } from 'reactstrap';

import CurrencyFormat from '../../generic/CurrencyFormat';
import { changeRequestShape } from '../../prop-types';
import { allTargetKpis } from '../../quote-editor/utils/TargetKpi/constants';
import { getCampaignDiff } from '../utils';

function displayTargetValue(targetKpi, targetKpiValue) {
  const kpiOption = allTargetKpis.find(kpi => kpi.value === targetKpi);
  if (kpiOption.currency) {
    return <CurrencyFormat value={targetKpiValue} text />;
  }
  return <span>{targetKpiValue.toString()}</span>;
}

function ChangeTargetComment({ changeRequest }) {
  const diffObject = getCampaignDiff(changeRequest);
  const draftCampaign = changeRequest.draftCampaigns[0];
  if (!diffObject) {
    return null;
  }
  const { targetKpi, targetKpiValue } = diffObject;

  const currentKPI = targetKpi
    ? targetKpi.originValue
    : draftCampaign.targetKpi;

  const currentKPIValue = targetKpiValue
    ? displayTargetValue(currentKPI, targetKpiValue.originValue)
    : displayTargetValue(currentKPI, draftCampaign.targetKpiValue);

  const newKPI = targetKpi ? targetKpi.draftValue : '';

  const newKPIValue = displayTargetValue(
    targetKpi ? targetKpi.draftValue : currentKPI,
    targetKpiValue ? targetKpiValue.draftValue : draftCampaign.targetKpiValue,
  );

  return (
    <Table striped size="sm" className="mb-2 small">
      <thead>
        <tr>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <th className="border-top-0" />
          <th className="border-top-0">Target KPI</th>
          <th className="border-top-0">Value</th>
        </tr>
      </thead>
      <tbody>
        <tr className="qa-current">
          <td>Current</td>
          <td>{currentKPI}</td>
          <td>{currentKPIValue}</td>
        </tr>
        <tr className="qa-new">
          <td>New</td>
          <td>{newKPI}</td>
          <td>{newKPIValue}</td>
        </tr>
      </tbody>
    </Table>
  );
}

ChangeTargetComment.propTypes = {
  changeRequest: changeRequestShape.isRequired,
};

export default ChangeTargetComment;
